import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as ResearchActionCreators from "../../../actions/research.actions";
import UploadTemporaryFile from '../../controls/UploadTemporaryFile';
import InlineTextEdit from '../../Controls/InlineTextEdit';
import InlineTextDisplay from '../../Controls/InlineTextDisplay';
import Select from "react-select";
import "react-select/dist/react-select.css";

export interface IResearchProps {
    research: CreDtos.Research;
    focus: CreDtos.Focus[];
    states: CreDtos.State[];
    publications: CreDtos.Publication[];
    people: CreDtos.People[];
    cancel: Function;
    upsert: Function;
    isSaving: boolean;
}

interface IResearchState {
    research: CreDtos.Research;
    focus: any[];
    states: any[];
    publications: any[];
    internalPeople: any[];
    externalPeople: any[];
}

class ResearchItem extends React.Component<IResearchProps, IResearchState> {
    constructor(props: IResearchProps) {
        super(props);
        this.state = {
            research: new CreDtos.Research(),
            focus: [],
            states: [],
            publications: [],
            internalPeople: [],
            externalPeople: []
        }
        this.onValueChanged = this.onValueChanged.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onAddContact = this.onAddContact.bind(this);
        this.onUpdateContact = this.onUpdateContact.bind(this);
    }

    componentDidMount() {
        this.onUpdateStateFromProps();
    }

    componentDidUpdate(prevProps) {
        if (this.state.research.id != this.props.research.id) {
            this.onUpdateStateFromProps();
        }
    }

    onUpdateStateFromProps() {
        let focus = [];

        if (this.props.research.researchFocus) {
            focus = this.props.research.researchFocus.filter(f => f.enabled).map((item, index) => {
                return {
                    label: item.focus.focusName,
                    value: item.focusId
                };
            });
        }
        let states = [];
        if (this.props.research.researchState) {
            states = this.props.research.researchState.filter(f => f.enabled).map((item, index) => {
                return {
                    label: item.state.stateName,
                    value: item.stateId
                };
            });
        }
        let publications = [];
        if (this.props.research.researchPublication) {
            publications = this.props.research.researchPublication.filter(f => f.enabled).map((item, index) => {
                return {
                    label: item.publication.display,
                    value: item.publicationId
                };
            });
        }

        let internalPeople = [];
        if (this.props.research.researchPeopleInternal) {
            internalPeople = this.props.research.researchPeopleInternal.filter(f => f.enabled).map((item, index) => {
                if (item.peopleCategoryId == 0) {
                    return {
                        label: item.people.title,
                        value: -1 * item.peopleId
                    };
                }
                return {
                    label: item.people.title + " ( " + item.peopleCategory.categoryName + " )",
                    value: item.peopleCategoryId
                };
            });
        }
        let externalPeople = [];
        if (this.props.research.researchPeopleExternal) {
            externalPeople = this.props.research.researchPeopleExternal.filter(f => f.enabled).map((item, index) => {
                return {
                    label: item.people.title,
                    value: item.peopleId
                };
            });
        }

        this.setState({ research: { ...this.props.research }, focus, states, publications, internalPeople, externalPeople });
    }

    onValueChanged(fieldName: string, value: any) {
        var research = { ...this.state.research };
        if (fieldName == "focus") {
            this.setState({ focus: value });
            research.researchFocus = value.map((item, index) => {
                let researchFocus = new CreDtos.ResearchFocus();
                researchFocus.focus = new CreDtos.Focus();
                researchFocus.enabled = true;
                researchFocus.focusId = item.value;
                researchFocus.focus.id = item.value;
                researchFocus.focus.focusName = item.label;
                return researchFocus;
            });
        }
        else if (fieldName == "states") {
            this.setState({ states: value });
            research.researchState = value.map((item, index) => {
                let researchState = new CreDtos.ResearchState();
                researchState.state = new CreDtos.State();
                researchState.enabled = true;
                researchState.stateId = item.value;
                researchState.state.id = item.value;
                researchState.state.stateName = item.label;
                return researchState;
            });
        }
        else if (fieldName == "publications") {
            this.setState({ publications: value });
            research.researchPublication = value.map((item, index) => {
                let researchPublication = new CreDtos.ResearchPublication();
                researchPublication.publication = new CreDtos.Publication();
                researchPublication.enabled = true;
                researchPublication.publicationId = item.value;
                researchPublication.publication.id = item.value;
                researchPublication.publication.display = item.label;
                return researchPublication;
            });
        }
        else if (fieldName == "externalPeople") {
            this.setState({ externalPeople: value });
            research.researchPeopleExternal = value.map((item, index) => {
                let researchPeople = new CreDtos.ResearchPeople();
                researchPeople.people = new CreDtos.People();
                researchPeople.enabled = true;
                researchPeople.peopleId = item.value;
                researchPeople.people.id = item.value;
                researchPeople.people.title = item.label;
                return researchPeople;
            });
        }
        else if (fieldName == "internalPeople") {
            this.setState({ internalPeople: value });
            research.researchPeopleInternal = value.map((item, index) => {
                if (item.value < 0) {
                    let researchPeople = new CreDtos.ResearchPeople();
                    researchPeople.people = new CreDtos.People();
                    researchPeople.enabled = true;
                    researchPeople.peopleId = -1 * item.value;
                    researchPeople.people.id = -1 * item.value;
                    researchPeople.people.title = item.label;
                    return researchPeople;
                } else {
                    let researchPeople = new CreDtos.ResearchPeople();
                    researchPeople.people = new CreDtos.People();
                    researchPeople.peopleCategory = new CreDtos.PeopleCategory();
                    researchPeople.enabled = true;
                    researchPeople.peopleCategoryId = item.value;
                    researchPeople.peopleCategory.id = item.value;
                    researchPeople.peopleCategory.categoryName = item.label;
                    return researchPeople;
                }
            });
        } else {
            research[fieldName] = value;
        }
        this.setState({ research })
    }

    onSave() {
        this.props.upsert(this.state.research);
    }

    onAddContact() {
        var research = { ...this.state.research };
        if (!research.researchContact) {
            research.researchContact = [];
        }
        let researchContact = new CreDtos.ResearchContact();
        researchContact.enabled = true;
        research.researchContact.push(researchContact);
        this.setState({ research })
    }

    onUpdateContact(index: number, fieldName: string, value: any) {
        var research = { ...this.state.research };
        research.researchContact[index][fieldName] = value;
        this.setState({ research });
    }

    render() {
        let content;

        if (this.state.research) {

            let img = this.state.research.images;
            if (!img || img.length == 0) {
                img = "./images/Unconfirmed.png";
            }


            let focusOptions = [];
            if (this.props.focus) {
                focusOptions = this.props.focus.filter(f => f.enabled).map((e, key) => {
                    return {
                        label: e.focusName,
                        value: e.id
                    }
                });
            }

            let stateOptions = [];
            if (this.props.states) {
                stateOptions = this.props.states.filter(f => f.enabled).map((e, key) => {
                    return {
                        label: e.stateName,
                        value: e.id
                    }
                });
            }

            let publicationOptions = [];
            if (this.props.publications) {
                publicationOptions = this.props.publications.filter(f => f.enabled).map((e, key) => {
                    return {
                        label: e.display,
                        value: e.id
                    }
                });
            }

            let peopleInternalOptions = [];
            if (this.props.people) {
                this.props.people.filter(f => f.enabled && f.peopleType == 2).forEach(p => {
                    if (p.peopleCategories && p.peopleCategories.length > 0) {
                        p.peopleCategories.forEach(pc => {
                            peopleInternalOptions.push({
                                label: p.title + " (" + pc.categoryName + " )",
                                value: pc.id
                            });
                        });
                    } else {
                        peopleInternalOptions.push({
                            label: p.title,
                            value: -1 * p.id
                        });
                    }
                    
                });
            }

            let peopleExternalOptions = [];
            if (this.props.people) {
                this.props.people.filter(f => f.enabled && f.peopleType == 0).forEach(p => {
                    peopleExternalOptions.push({
                        label: p.title,
                        value: p.id
                    });
                });
            }

            let researchContacts;
            if (this.state.research.researchContact) {
                researchContacts = this.state.research.researchContact.map((item, index) => {
                    return (
                        <div className="row" key={"researchContact_" + item.id + "_" + index.toString()}>
                            {item.enabled && (
                                <div className="col-12">
                                    <div className="card grey-bg">
                                        <div className="card-block">
                                            <div className="row">
                                                <div className="col-12 mb-1 ">
                                                    <div className="mb-0 form-group">
                                                        <label>Name</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            placeholder=""
                                                            disabled={this.props.isSaving}
                                                            value={item.name}
                                                            onChange={e => this.onUpdateContact(index, "name", e.target.value)}
                                                            maxLength={255} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 mb-1 ">
                                                    <div className="mb-0 form-group">
                                                        <label>Email</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            placeholder=""
                                                            disabled={this.props.isSaving}
                                                            value={item.email}
                                                            onChange={e => this.onUpdateContact(index, "email", e.target.value)}
                                                            maxLength={255} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 mb-1 ">
                                                    <div className="mb-0 form-group">
                                                        <label>Subject</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            placeholder=""
                                                            disabled={this.props.isSaving}
                                                            value={item.subject}
                                                            onChange={e => this.onUpdateContact(index, "subject", e.target.value)}
                                                            maxLength={255} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 mb-1 ">
                                                    <button type="button" className="btn btn-danger btn-sm" disabled={this.props.isSaving} onClick={() => this.onUpdateContact(index, "enabled", false)}>Remove</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
                });
            }

            let researchContact = (
                <div className="col-12">
                    <div className="row">
                        <div className="col-12">
                            <strong>Contacts</strong>
                        </div>
                        <div className="col-12">
                            {researchContacts}
                        </div>
                        <div className="col-12 mb-1 ">
                            <button type="button" className="btn btn-primary btn-sm" disabled={this.props.isSaving} onClick={() => this.onAddContact()}>Add Contact</button>
                        </div>
                    </div>
                </div>
            );

            content = (
                <div className="card lightgrey-bg">
                    <div className="card-block">
                        <div className="row">
                            <div className="col-12 col-md-9 push-md-3">
                                <div className="row">
                                    <div className="col-12 mb-1 ">
                                        <strong>Project</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="Title..."
                                                disabled={this.props.isSaving}
                                                value={this.state.research.title}
                                                onChange={(e) => this.onValueChanged("title", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="Only required when controlling the title wrapping..."
                                                disabled={this.props.isSaving}
                                                value={this.state.research.summaryTitleLine1}
                                                onChange={(e) => this.onValueChanged("summaryTitleLine1", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="Only required when controlling the title wrapping..."
                                                disabled={this.props.isSaving}
                                                value={this.state.research.summaryTitleLine2}
                                                onChange={(e) => this.onValueChanged("summaryTitleLine2", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="Anchor..."
                                                disabled={this.props.isSaving}
                                                value={this.state.research.anchor}
                                                onChange={(e) => this.onValueChanged("anchor", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <label>
                                            <input type="checkbox"
                                                checked={this.state.research.recruiting}
                                                disabled={this.props.isSaving}
                                                onClick={() => this.onValueChanged("recruiting", !this.state.research.recruiting)}
                                            />
                                            Recruiting
                                        </label>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <UploadTemporaryFile onUpdated={(path) => this.onValueChanged("images", path)} />
                                        <p>The preferred aspect ratio 5:3</p>
                                    </div>
                                    <div className="col-12">
                                        <strong>Funding Body</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <InlineTextEdit source={this.state.research.fundingBody} onChange={value => this.onValueChanged("fundingBody", value)} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <strong>Content</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <InlineTextEdit source={this.state.research.content} onChange={value => this.onValueChanged("content", value)} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <strong>Focus</strong>
                                    </div>
                                    <div className="col-12">
                                        <div className="mb-0 form-group">
                                            <Select
                                                name="Filters"
                                                placeholder={"Focus"}
                                                value={this.state.focus}
                                                options={focusOptions}
                                                onChange={values => this.onValueChanged("focus", values)}
                                                multi={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <strong>States</strong>
                                    </div>
                                    <div className="col-12">
                                        <div className="mb-0 form-group">
                                            <Select
                                                name="Filters"
                                                placeholder={"States"}
                                                value={this.state.states}
                                                options={stateOptions}
                                                onChange={values => this.onValueChanged("states", values)}
                                                multi={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <strong>Publications</strong>
                                    </div>
                                    <div className="col-12">
                                        <div className="mb-0 form-group">
                                            <Select
                                                name="Publications"
                                                placeholder={"Publications"}
                                                value={this.state.publications}
                                                options={publicationOptions}
                                                onChange={values => this.onValueChanged("publications", values)}
                                                multi={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <strong>Researchers</strong>
                                    </div>
                                    <div className="col-12">
                                        <div className="mb-0 form-group">
                                            <Select
                                                name="InternalResearchers"
                                                placeholder={"Internal Researchers"}
                                                value={this.state.internalPeople}
                                                options={peopleInternalOptions}
                                                onChange={values => this.onValueChanged("internalPeople", values)}
                                                multi={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 show-sm">
                                        <div>
                                            <img src={img} style={{width: "100%"}} />
                                        </div>
                                        <div className="pull-left">
                                            <button type="button" className="btn btn-danger btn-sm" disabled={this.props.isSaving} onClick={() => this.onValueChanged("images", "")}>Remove</button>
                                        </div>
                                    </div>
                                    {researchContact}
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label >Sort Order</label>
                                            <input type="number"
                                                className="form-control"
                                                disabled={this.props.isSaving}
                                                placeholder="0"
                                                value={this.state.research.sortOrder}
                                                onChange={e => this.onValueChanged("sortOrder", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <label>
                                            <input type="checkbox"
                                                checked={this.state.research.enabled}
                                                disabled={this.props.isSaving}
                                                onClick={() => this.onValueChanged("enabled", !this.state.research.enabled)}
                                            />
                                            Enabled
                                        </label>
                                    </div>
                                    <div className="col-12">
                                        <p></p>
                                    </div>
                                    <div className="col-12">
                                        <div className="pull-right">
                                            <button type="reset" className="btn btn-primary mr-2" disabled={this.props.isSaving} onClick={() => this.props.cancel()}>CANCEL</button>
                                            <button type="button" className="btn btn-primary" disabled={this.props.isSaving} onClick={() => this.onSave()}>SAVE</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-12 col-md-3 pull-md-9 hide-sm">
                                <div>
                                    <img src={img} style={{width: "100%"}} />
                                </div>
                                <div className="pull-left">
                                    <button type="button" className="btn btn-danger btn-sm" disabled={this.props.isSaving} onClick={() => this.onValueChanged("images", "")}>Remove</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            );
        }

        return (
            <div>
                {content}
            </div>
        );

    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        research: state.research.researchItem,
        focus: state.research.focus,
        states: state.research.states,
        publications: state.research.publications,
        people: state.research.people,
        isSaving: state.research.isSaving
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            cancel: ResearchActionCreators.researchCancel,
            upsert: ResearchActionCreators.researchUpsertRequest
        },
        dispatch
    );
};


const ResearchItemContainer = connect(mapStateToProps, mapDispatchToProps)(
    ResearchItem
);

export default ResearchItemContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/Research/ResearchItem.tsx